// import qs from 'qs';

import Axios from '../utils/request';


// 登录
const Login = params => Axios.post('/channel/auth/login',params);
// 用户信息
const auth_user=()=> Axios.get('/channel/auth/user')
// 退出登录
export default { Login, LoginOut ,auth_user };


const LoginOut = () => Axios.get('/channel/auth/logout');
  export const channel_songlist =(params)=>{
      return Axios.get('channel/songlist',{params})
  }

  export const export_Material =(params)=>Axios.post('channel/exportMaterial',params)

  export const export_PageMaterial=(params)=>Axios.post('channel/exportPageMaterial',params)
// 下载详情页面
  export const download_Material=(params)=>Axios.post('channel/downloadMaterial',params)
// 取消下载
  export const terminate_Material=(params)=>Axios.post('channel/terminateMaterial',params)
//删除
export const terminate_PageMaterial=(params)=>Axios.post('channel/deleteMaterial',params)
// 修改密码
export const auth_resetpwd=(params)=>Axios.post('channel/auth/resetpwd',params)
//导出表格
export const channel_exportDownloadSong = (params)=>Axios.get('channel/exportDownloadSong/' + params,{responseType:"blob"})
//下载次数
export const channel_downloadMaterialZip = (params)=>Axios.get('channel/downloadMaterialZip/' + params)



// WEBPACK FOOTER //
// ./src/api/index.js